import {Translator} from "../component/const";
import {includes} from "../component/Function";
import {useContext, useEffect} from "react";
import {Context} from "../component/context";

export const Trans = () => {

    const {meta: metaData, setMeta: setMetaData, isTS, path} = useContext(Context);

    useEffect(() => {
        if (path !== 'trans') return
        setMetaData({
            translator: [Translator[0]],
            to_sound: false,
        })
    }, [path]);

    useEffect(() => {
    }, [metaData]);

    const changeTranslators = (value) => {
        let trans = [...metaData.translator]
        if (includes(trans, value)) setMetaData(prev => ({...prev, translator: trans.filter(it => it !== value)}))
        else if (trans.length === 4) alert("최대 4개만 선택 가능합니다.")
        else if (!Array.isArray(trans)) setMetaData(prev => ({...prev, translator: [value]}))
        else {
            trans.push(value)
            setMetaData(prev => ({...prev, translator: trans}))
        }
    }

    const onChangeMeta = (value, toChange) => {
        setMetaData(prev => ({
            ...prev,
            [toChange]: value
        }))
    }

    return <div className='w-full  h-screen overflow-x-scroll hidden templates' id='trans'>
        번역
        <table className="overflow-x-auto p-4 [&_tr]: m-4">
            <thead className="bg-gray-100">
            <tr>
                <th className="px-4 py-4 border text-xl">사용 가능 AI</th>
                {isTS && <th className="px-4 py-4 border text-xl">답변시 음성 재생</th>}
            </tr>
            </thead>
            <tbody>
            <tr>
                <td className="px-4 py-4 border text-xl">
                    {Translator.map((it, index) =>
                        (<label key={`Create Trans SubmitMetaData checkBox ${index}`}>
                            <input type="checkbox" style={{height: "auto"}}
                                   checked={includes(metaData.translator, it)}
                                   onChange={() => changeTranslators(it)}/>
                            {it}
                        </label>))}
                </td>
                {isTS && <td className="px-4 py-4 border text-xl">
                    <label>
                        <input type="checkbox" style={{height: "auto"}}
                               checked={metaData.to_sound}
                               onChange={() => onChangeMeta(!metaData.to_sound, 'to_sound')}/>
                        소리 재생
                    </label>
                </td>}
            </tr>
            </tbody>
        </table>
    </div>
}